import React from 'react';
import { FileText, Image, Package, Palette, Printer, ShoppingBag } from 'lucide-react';

const Products = () => {
  const products = [
    {
      icon: <FileText className="text-silver-300" size={40} />,
      title: 'Business Cards',
      description: 'Premium quality business cards with various finishes and materials.',
      image: `${process.env.PUBLIC_URL}/products/visiting_cards.png`
    },
    {
      icon: <Image className="text-silver-300" size={40} />,
      title: 'Banners & Posters',
      description: 'Large format printing for eye-catching displays and promotions.',
      image: `${process.env.PUBLIC_URL}/products/banners.png`
    },
    {
      icon: <Package className="text-silver-300" size={40} />,
      title: 'Packaging',
      description: 'Custom packaging solutions that make your products stand out.',
      image: `${process.env.PUBLIC_URL}/products/packaging.png`
    },
    {
      icon: <Palette className="text-silver-300" size={40} />,
      title: 'Brochures',
      description: 'Professional brochures and catalogs for your marketing needs.',
      image: `${process.env.PUBLIC_URL}/products/brochures.png`
    },
    {
      icon: <Printer className="text-silver-300" size={40} />,
      title: 'Stationery',
      description: 'Complete stationery sets including letterheads and envelopes.',
      image: `${process.env.PUBLIC_URL}/products/stationery.png`
    },
    {
      icon: <ShoppingBag className="text-silver-300" size={40} />,
      title: 'Promotional Items',
      description: 'Custom printed promotional products for brand awareness.',
      image: `${process.env.PUBLIC_URL}/products/promotional_items.png`
    }
  ];

  return (
    <section id="products" className="py-20 bg-gradient-to-b from-navy-800 to-navy-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our <span className="text-silver-300">Products</span>
          </h2>
          <p className="text-xl text-silver-400 max-w-3xl mx-auto">
            Explore our comprehensive range of digital printing services designed to meet all your business needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div 
              key={index}
              className="group bg-navy-700/50 backdrop-blur-sm rounded-xl overflow-hidden border border-silver-600/30 hover:border-silver-400/50 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900/90 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  {product.icon}
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-3">{product.title}</h3>
                <p className="text-silver-400">{product.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
